<template>


    <div class="lw-course-contents-chapter mb-6rem" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center mb-2rem">
            <div class="lw-course-contents-chapter-num col span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp">
                <h3 class="no-margin-bottom learnworlds-element lw-course-chapter-circle flexible-part lw-brand-accent1-bg">
                    <span class="lw-course-chapter-num learnworlds-heading3 learnworlds-heading3-normal learnworlds-element">{{sectionNumber}}</span>
                </h3>
            </div>
            <div class="col span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp">
                <div class="with-flexible-parts align-items-center justify-content-space-between">
                    <h3 class="no-margin-bottom learnworlds-heading3 learnworlds-heading3-small learnworlds-element">{{sectionTitle}}</h3>
                    <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny" v-if="displayAccessLabel && sectionAccess !== 'premium'">{{sectionDisplayedAccessLabel}}</div>
                    
                    <!-- drip feed -->
                    <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                        <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                        <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
                    </div>
                    <!----->
                </div>
                
                <div v-if="sectionDescription" class="mt-10 no-margin-bottom learnworlds-main-text-normal">{{ sectionDescription }}</div>
                
            </div>
        </div>
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp">
            <div class="lw-course-contents-chapter-num col span_2_of_12 span_2_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp flex-item">

            </div>
            <div class="col span_10_of_12 span_10_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp flex-item">
                <div class="lw-course-contents-units">
                    <div class="with-flexible-parts lw-course-contents-unit lw-bb-1px-fadeout90 ptb-1rem justify-content-space-between" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">

                        <div class="with-flexible-parts align-items-center">
                            <unit-icon class="lw-contents-svg normal" :icon="unit.icon"></unit-icon>
                            <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-element learnworlds-main-text-normal">{{unit.title}}</div>
                            <span class="ml-10px no-margin-bottom learnworlds-main-text-normal learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
                            <span class="ml-10px no-margin-bottom learnworlds-main-text-normal lw-brand-text learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>
                        </div>

                        <div class="hide-sp ml-10px no-margin-bottom learnworlds-main-text learnworlds-element learnworlds-main-text-normal lw-text-color-fadeout50" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">{{getUnitExtraInfo(unit)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate1",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin]
    }
</script>

